// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"c348b361","453":"9a8b4708","709":"a25c5d72"}[chunkId] + ".chunk.js";
};